/**
 * Returns a bucket key for the current hour. Empty-state copy keys hang off
 * this. Note: matches the buckets defined in MASTER.md §10.
 */
export function getTimeOfDayBucket(now: Date = new Date()): 'morning' | 'midday' | 'afternoon' | 'evening' | 'late' | 'deep_night' {
  const h = now.getHours();
  if (h >= 6 && h < 10) return 'morning';
  if (h >= 10 && h < 14) return 'midday';
  if (h >= 14 && h < 17) return 'afternoon';
  if (h >= 17 && h < 22) return 'evening';
  if (h >= 22 || h < 2) return 'late';
  return 'deep_night';
}
